import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { fetchSkills, fetchSpecialization } from '../../redux/action/commonAction';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Image from '../../components/general/Image';
import Button from '../../components/general/Button';
import Input from '../../components/general/Input';

const HireDevelopers = () => {
  const dispatch = useDispatch()
  const { isTechLoading, technologies } = useSelector(state => state.common.tech);
  const { isLoading, specializationList } = useSelector(state => state.common.spec);
  const [search, setSearch] = useState('')


  useEffect(() => {
    if (!isLoading) return;
    dispatch(fetchSpecialization())
    // eslint-disable-next-line
  }, [isLoading])

  useEffect(() => {
    if (!isTechLoading) return;
    dispatch(fetchSkills());
    // eslint-disable-next-line
  }, [isTechLoading])

  const filteredTechnologies = useMemo(() => {
    return technologies.filter(tech => tech.name.toLowerCase().includes(search.toLowerCase())).slice(0, 53)
  }, [technologies, search])

  return (
    <div className="mt-[50px]">
      <h4 className='text-[30px] font-semibold'>Hire developers by role</h4>
      <ul className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-[20px] mt-[20px] min-h-[160px]">
        {
          specializationList.map((spec, index) =>
            <Link to={`/hire/role/${spec.slug}`} key={index} className='bg-[#292929] rounded-[10px] p-[20px] flex flex-col justify-center items-center hover:scale-105 transition-all duration-300'>
              <li>
                <figure className='flex justify-center items-center'>
                  {
                    spec.icon_details ? (
                      <Image src={spec.icon_details?.file} className='w-[40px] h-[40px]' alt="" />
                    )
                      :
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 w-[40px] h-[40px] text-white">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M4.26 10.147a60.438 60.438 0 0 0-.491 6.347A48.62 48.62 0 0 1 12 20.904a48.62 48.62 0 0 1 8.232-4.41 60.46 60.46 0 0 0-.491-6.347m-15.482 0a50.636 50.636 0 0 0-2.658-.813A59.906 59.906 0 0 1 12 3.493a59.903 59.903 0 0 1 10.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.717 50.717 0 0 1 12 13.489a50.702 50.702 0 0 1 7.74-3.342M6.75 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm0 0v-3.675A55.378 55.378 0 0 1 12 8.443m-7.007 11.55A5.981 5.981 0 0 0 6.75 15.75v-1.5" />
                      </svg>
                  }
                </figure>
                <figcaption className='text-center mt-[20px] text-[16px] font-light bg-[#292929] p-[10px]'>
                  {spec.name}
                </figcaption>
              </li>
            </Link>
          )
        }
        <Link to={`#`} className='block bg-[#292929] rounded-[10px] p-[20px] min-h-[160px]'>
          <li>
            <figcaption className='text-center mt-[20px] text-[0.7rem] font-light bg-[#292929] p-[10px]'>
              Looking for other role?
            </figcaption>
            <Button className='bg-primary-color text-black w-[100%] h-[50px] mx-auto rounded text-[0.8rem]'>Place request <i className="fa-solid fa-arrow-up-right" /></Button>
          </li>
        </Link>
      </ul>

      <div className='flex flex-col md:flex-row justify-between items-center mt-[50px]'>
        <h4 className='text-[30px] font-semibold'>Hire developers by skill</h4>
        <div className='mt-[10px] md:mt-0'>
          <Input
            placeholder='Type here to search skills'
            onChange={(e) => setSearch(e)}
            className=''
          />
        </div>
      </div>
      <ul className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-[20px] mt-[20px]">

        {
          Boolean(filteredTechnologies?.length) && filteredTechnologies.map((tech, index) =>
            <Link to={`/hire/skill/${tech.slug}`} key={index} className='bg-[#292929] rounded-[10px] p-[20px] min-h-[160px] flex flex-col justify-center items-center hover:scale-105 transition-all duration-300'>
              <li>
                <figure className='flex justify-center items-center'>
                  {
                    tech.icon_details ? (
                      <Image src={tech.icon_details?.file} className='w-[40px] h-[40px]' alt="" />
                    )
                      :
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 w-[40px] h-[40px] text-white">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M4.26 10.147a60.438 60.438 0 0 0-.491 6.347A48.62 48.62 0 0 1 12 20.904a48.62 48.62 0 0 1 8.232-4.41 60.46 60.46 0 0 0-.491-6.347m-15.482 0a50.636 50.636 0 0 0-2.658-.813A59.906 59.906 0 0 1 12 3.493a59.903 59.903 0 0 1 10.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.717 50.717 0 0 1 12 13.489a50.702 50.702 0 0 1 7.74-3.342M6.75 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm0 0v-3.675A55.378 55.378 0 0 1 12 8.443m-7.007 11.55A5.981 5.981 0 0 0 6.75 15.75v-1.5" />
                      </svg>
                  }
                </figure>
                <figcaption className='text-center mt-[20px] text-[16px] font-light bg-[#292929] p-[10px]'>
                  {tech.name}
                </figcaption>
              </li>
            </Link>
          )
        }
        <Link to={`#`} className='block bg-[#292929] rounded-[10px] p-[20px] min-h-[160px]'>
          <li>
            <figcaption className='text-center mt-[20px] text-[0.7rem] font-light bg-[#292929] p-[10px]'>
              Looking for other skill?
            </figcaption>
            <Button className='bg-primary-color text-black w-[100%] h-[50px] mx-auto rounded text-[0.8rem]'>Place request <i className="fa-solid fa-arrow-up-right" /></Button>
          </li>
        </Link>
      </ul>
    </div>
  );
};

export default HireDevelopers;